import React from 'react';

interface Props {
  x: number;
  y: number;
  onSelect: (color: string) => void;
  onClose: () => void;
}

const COLORS = ['#fef08a', '#fbcfe8', '#bbf7d0', '#bfdbfe', '#ddd6fe'];

const ColourPickerPopover: React.FC<Props> = ({ x, y, onSelect, onClose }) => {
  return (
    <div
      style={{ top: y, left: x }}
      className="fixed z-50 bg-white shadow-lg rounded p-2 flex gap-2"
      onMouseLeave={onClose}
    >
      {COLORS.map((c) => (
        <button
          key={c}
          onClick={() => { onSelect(c); onClose(); }}
          style={{ backgroundColor: c }}
          className="w-6 h-6 rounded border"
        />
      ))}
    </div>
  );
};

export default ColourPickerPopover; 